// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2QtWG","inputWrap":"CustomTip_inputWrap__19qab"};